<template>
  <div class="notice-warpper">
    <div class="logo">
      <img src="../../assets/img/h5-logo.png" alt="" />
    </div>

    <div class="notice-info">
      <h3 class="detail-title">{{ title }}</h3>
      <p class="detail-time">发布时间：{{ time }}</p>
      <div class="detail-html" v-html="content"></div>
      <div class="flex-list margin-top" v-if="attached_file.length > 0">
        附件：
        <p v-for="(item, index) in attached_file" :key="index">
          <el-link type="primary" :href="showhost + item.url" target="_blank">{{
            item.name
          }}</el-link>
        </p>
      </div>
    </div>
    <div class="footer-btn">
      <el-button type="primary" @click="toSignUp">立即报名</el-button>
    </div>
  </div>
</template>

<script>
import { SHOWHOST } from '@/config/index'
import { noticeDetail2h5 } from '@/api/member'
export default {
  name: "notice",
  data () {

    return {
      id:'',
      title: '',
      time: '',
      content: '',
      notice_type: '',
      attached_file: [],
    }
  },
  computed: {

    showhost () {
      return SHOWHOST
    },

  },
  components: {

  },
  created () {
    this.id = this.$route.params.id
    this.getDetail()
  },
  mounted () {

  },
  methods: {
    toSignUp(){
      this.$router.push('/mnoticeSignup/' + this.id + '?title=' + this.title)
    },
    async getDetail () {
      let _data = await noticeDetail2h5(this.$route.params.id)
      if (_data.data.replyInfo) _data.data.replyInfo.attached_file = JSON.parse(_data.data.replyInfo.attached_file)
      this.title = _data.data.title
      this.time = _data.data.create_time
      this.content = _data.data.content
      this.attached_file = JSON.parse(_data.data.attached_file)
    }
  }
}
</script>

<style scoped lang="scss">
.notice-warpper {
  height: 100vh;
  overflow-y: scroll;
  padding-bottom: 68px;
  background: url(../../assets/img/h5-bg.png) no-repeat top center;
  .logo {
    padding: 30px;
    img {
      display: block;
      width: 100%;
    }
  }
  .notice-info {
    margin: 0 15px;
    background: #fff;
    border-radius: 8px;
    padding: 15px;
    .detail-title {
      font-size: 18px;
      line-height: 30px;
      margin-bottom: 5px;
      text-align: center;
    }
    .detail-time {
      color: #999;
      padding-bottom: 20px;
      margin-bottom: 20px;
      border-bottom: 1px solid #ccc;
      text-align: center;
    }
  }
  .footer-btn {
    position: fixed;
    left: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    padding: 4px;
    height: 48px;
    background: #fff;
    .el-button {
      width: 60%;
    }
  }
}
</style>